import React from 'react'
import Section from './Section'
import { LinkToProductSearch } from '../../components/Links/LinkToProductSearch'
import type { VideoCardProps } from './VideoCard'
import { VideoCard } from './VideoCard'
import { Col, Row } from 'react-bootstrap'
import { routesDef } from '../../config/routes'

const videos: VideoCardProps[] = [
  {
    url: 'https://www.youtube.com/embed/lt-zKKVtVKo',
    subtitle: 'How our hydraulic works',
    redirectUrl: routesDef.ProductListPage.altPath({ categoryFilter: 'HYD' }),
  },
  {
    url: 'https://www.youtube.com/embed/Etc7h7859-8',
    subtitle: 'Using Dandy Die Round',
    redirectUrl: routesDef.ProductListPage.altPath({ categoryFilter: 'DIE' }),
  },
  {
    url: 'https://www.youtube.com/embed/4UBqHsqekAs',
    subtitle: 'Using our dandy dies',
    redirectUrl: routesDef.ProductListPage.altPath({ categoryFilter: 'DIE' }),
  },
  {
    url: 'https://www.youtube.com/embed/Koyppgpp2CY',
    subtitle: 'About us and how we work.',
    redirectUrl: routesDef.PostItemPage.altPath('about-us'), //post/about-us
  },
]

export const ProductsInAction = () => {
  return (
    <Section title="Our products in action">
      <Row className="g-3">
        {videos.map((video) => (
          <Col key={video?.url} md={6}>
            <VideoCard {...video} />
          </Col>
        ))}
      </Row>

      <div>
        <LinkToProductSearch className="btn btn-primary ">See all of our products...</LinkToProductSearch>
      </div>
    </Section>
  )
}
